var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolarEnergyColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path219",
    d: "M0-682.665H21v21H0Z",
    transform: "translate(0 682.665)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar-energy",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g217",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g223",
    transform: "translate(4.553 4.553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path225",
    d: "M0-187.386a5.947,5.947,0,0,1,5.947-5.947,5.947,5.947,0,0,1,5.947,5.947,5.947,5.947,0,0,1-5.947,5.947A5.947,5.947,0,0,1,0-187.386Z",
    transform: "translate(0 193.333)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g227",
    transform: "translate(10.5 0.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path229",
    d: "M0,0V1.379",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g231",
    transform: "translate(16.514 3.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path233",
    d: "M-30.721,0-31.7.975",
    transform: "translate(31.696)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g235",
    transform: "translate(19.006 10.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path237",
    d: "M-43.445,0h-1.379",
    transform: "translate(44.824)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g239",
    transform: "translate(16.514 16.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path241",
    d: "M-30.721-30.721-31.7-31.7",
    transform: "translate(31.696 31.696)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g243",
    transform: "translate(10.5 19.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path245",
    d: "M0-43.445v-1.379",
    transform: "translate(0 44.824)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g247",
    transform: "translate(3.511 16.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path249",
    d: "M0-30.721.975-31.7",
    transform: "translate(0 31.696)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g251",
    transform: "translate(0.615 10.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path253",
    d: "M0,0H1.379",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g255",
    transform: "translate(3.511 3.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path257",
    d: "M0,0,.975.975",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g259",
    transform: "translate(8.903 7.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path261",
    d: "M-55.8,0l-1.771,3.195h3.195l-1.944,3.368",
    transform: "translate(57.576)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarEnergyColored);
export default __webpack_public_path__ + "static/media/solar-energy-colored.a58b5b2d2fd62abdc413837674587539.svg";
export { ForwardRef as ReactComponent };